<template>
  <div id="setting-admin">
    <!-- page header -->
    <div class="bg-white shade py-2 px-3 mb-4" style="margin-top: 15px">
      <h3 style="font-size: 20px">
        <i class="bi bi-gear"></i>
        Settings
      </h3>
    </div>
    <tab-vertical-component
      :tabs="tabs"
      style="margin-left: -8px; margin-right: -8px"
    />
  </div>
</template>
<script>
import $ from "jquery";
import notif from "@/assets/js/notif.js";
import tab_vertical from "@/views/components/tab_vertical.vue";
import tab_announcement from "@/views/components/super-admin/tab_announcement.vue";
import tab_limit from "@/views/components/super-admin/tab_limit.vue";

$.pgNotificationimport = notif;

export default {
  name: "Settings",
  components: {
    "tab-vertical-component": tab_vertical,
  },
  data() {
    return {
      tabs: [
        {
          name: "Announcement",
          component: tab_announcement,
        },
        {
          name: "Limit Facebook & Instagram",
          component: tab_limit,
        },
      ],
    };
  },
};
</script>